/**
 * Returns false if input is greater than the set character maximum limit
 *
 * @param input
 * @param maxLimit
 * @returns true/false
 */
export const validateMaxCharacterLimit = (input: string, maxLimit: number): boolean => {
  return input.length <= maxLimit;
};
